export class ListLinkRegistriesByPropertyIdError extends Error {
}